module.exports = __webpack_public_path__ + "static/MTG-690af177f57d9c62a8e87bf2d3650a6b.png";